<div id="mainDIV">
    <section class="home_section mb-4">
        <div class="container-fluid">
            <app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
            <div class="row align-items-center">
                <div class="col-xl-12 col-sm-12 col-md-12 col-lg-12 hero-content">
                    <div class="col-md-12 col-lg-10 col-offset-2 m-auto">
                        <div class="row justify-content-center mt-3">
                            <div class="col-sm-12 col-md-12 col-lg-10 text-center m-auto">
                                <!-- <img class="mt-1 icon_set" src="../../../../assets/images/c6.png" alt=""> -->
 
                                <h4>Forgot Password ?</h4>
                  </div>
                            <div class="card _add_shadow mt-4" style="width: 80%">
                                <div class="card-body">
                                    <p class="forgt_text">Enter Your Registered Email</p>
                                    <form class="al_form"  [formGroup]="loginForm">
                                        <div class="form-group">
                                          <input type="text" name="Email Address" formControlName="email" placeholder="Email Address" class="al_input">
                                          <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)" class="errorinput text-left">
                                            <div *ngIf="loginForm.controls['email'].errors.required">
                                              *Email is required.
                                            </div>
                                            <div *ngIf="loginForm.controls['email'].errors.pattern">
                                                *Invalid email .
                                              </div>
                                        </div>
                                        </div>
                                      </form>
                                      <div class="row col-sm-12 col-md-12 mt-3 col-lg-12 m-auto justify-content-center">
                                        <button class="submit_btn m-1" [disabled]="!loginForm.valid" (click)="submitForm()"
                                            > SUBMIT</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>